import { render, staticRenderFns } from "./NewPasswordRequired.vue?vue&type=template&id=ceb6da52&scoped=true"
import script from "./NewPasswordRequired.vue?vue&type=script&lang=js"
export * from "./NewPasswordRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb6da52",
  null
  
)

export default component.exports